import React, { useRef, useState, useEffect } from "react";
import "./Contact.css";
import bannerimg from "../../media/bannerimg.jpg";
import PageBanner from "../components/PageBanner";
import emailjs from "@emailjs/browser";
import usePageTitle from "../components/usePageTitle";

const ContactPage = () => {
  usePageTitle("Contact");
  const form = useRef();
  const [statusMessage, setStatusMessage] = useState(null);
  const [isSuccess, setIsSuccess] = useState(true);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_xzni4ay",
        "template_5jb6wau",
        form.current,
        "hz_x1J0D66B2ymIw1"
      )
      .then(
        (result) => {
          setIsSuccess(true);
          setStatusMessage("Message sent successfully!");
          setTimeout(() => setStatusMessage(null), 4000);
        },
        (error) => {
          setIsSuccess(false);
          setStatusMessage("Something went wrong. Please try again.");
          setTimeout(() => setStatusMessage(null), 4000);
        }
      );

    e.target.reset();
  };

  return (
    <div className="contact-page">
      <PageBanner
        title="Contact Us"
        breadcrumb="Contact Us"
        bgImage={bannerimg}
      />

      <section className="contact-page__section py-5">
        <div className="container">
          {/* ✅ Info Boxes */}
          <div className="row contact-page__info-boxes mb-5">
            <div className="col-md-4 mb-4">
              <div className="contact-page__info-box p-4 text-center shadow-sm rounded">
                <i className="bi bi-geo-alt fs-1 mb-3"></i>
                <h5 className="contact-page__info-heading fw-bold mb-2">
                  Address Line
                </h5>
                <p className="contact-page__info-text mb-0">
                  4340 S Abilene Cir
                </p>
                <p className="contact-page__info-text">Aurora CO 80015</p>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="contact-page__info-box p-4 text-center shadow-sm rounded">
                <i className="bi bi-telephone fs-1 mb-3"></i>
                <h5 className="contact-page__info-heading fw-bold mb-2">
                  Phone Number
                </h5>
                <p className="contact-page__info-text mb-0">720-412-7990</p>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="contact-page__info-box p-4 text-center shadow-sm rounded">
                <i className="bi bi-envelope fs-1 mb-3"></i>
                <h5 className="contact-page__info-heading fw-bold mb-2">
                  Mail Address
                </h5>
                <p className="contact-page__info-text mb-0">
                  aspensrbusinesssolutions@gmail.com
                </p>
              </div>
            </div>
          </div>

          {/* ✅ Map & Form */}
          <div className="row g-5 contact-page__main-content">
            {/* Map */}
            <div className="col-md-6 contact-page__map">
              <h3 className="contact-page__title fw-bold mb-3">Get in touch</h3>
              <p className="contact-page__text">
                Get in touch with us today. We’re happy to answer your questions
                and help your business thrive.
              </p>
              <iframe
                title="Google Map"
                src="https://www.google.com/maps?q=39.637535,-104.828287&z=15&output=embed"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>

            {/* Form */}
            <div className="col-md-6 contact-page__form">
              <h3 className="contact-page__title fw-bold mb-3">
                Fill Up The Form
              </h3>
              <p className="contact-page__text">
                Your email address will not be published. Required fields are
                marked *
              </p>

              {/* ✅ Toast Notification */}
              {statusMessage && (
                <div
                  className={`contact-page__toast ${
                    isSuccess ? "success" : "error"
                  }`}
                >
                  <i
                    className={`bi ${
                      isSuccess ? "bi-check-circle" : "bi-x-circle"
                    }`}
                  ></i>
                  <span>{statusMessage}</span>
                </div>
              )}

              <form ref={form} onSubmit={sendEmail}>
                <div className="mb-3">
                  <input
                    type="text"
                    name="name"
                    className="contact-page__form-control form-control"
                    placeholder="Your Name*"
                    required
                  />
                </div>
                <div className="mb-3">
                  <input
                    type="email"
                    name="email"
                    className="contact-page__form-control form-control"
                    placeholder="Email Address*"
                    required
                  />
                </div>
                <div className="mb-3">
                  <input
                    type="text"
                    name="title"
                    className="contact-page__form-control form-control"
                    placeholder="Subject*"
                    required
                  />
                </div>
                <div className="mb-3">
                  <textarea
                    name="message"
                    className="contact-page__form-control form-control"
                    placeholder="Enter Your Message Here"
                    rows="5"
                    required
                  ></textarea>
                </div>
                <button
                  type="submit"
                  className="btn btn-dark contact-page__submit-btn"
                >
                  <i className="bi bi-send me-2"></i> Get In Touch
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
